import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import ScrollToTop from './helper/ScrollToTop';
import { GlobalStyle } from "./components/common/styles/global.js";
import HomeOne from './HomeOne';
import About from './pages/about/About';
import CourseGrid from './pages/courses/CourseGrid';
import CourseList from './pages/courses/CourseList';
import CourseDetails from './pages/courses/CourseDetails';
import Instructor from './pages/instructor/Instructors';
import InstructorDetails from './pages/instructor/InstructorDetails';
import UniversityDetails from './pages/universities/UniversityDetails';
import Gallery from './pages/gallery/Gallery';
import Events from './pages/events/Events';
import EventDetails from './pages/events/EventsDetails';
import Login from './pages/account/Login';
import Register from './pages/account/Register';
import ForgotPassword from './pages/account/ForgotPassword';
import ResetPassword from './pages/account/ResetPassword';
import Applications from './pages/account/Applications';
import Profile from './pages/account/Profile';
import AdminApplications from './pages/admin/AdminApplications';
import AdminBlogs from './pages/admin/AdminBlogs';
import AdminEvents from './pages/admin/AdminEvents';
import AdminInstructors from './pages/admin/AdminInstructors';
import AdminUsers from './pages/admin/AdminUsers';
import AdminGallery from './pages/admin/AdminGallery';
import AdminTestimonials from './pages/admin/AdminTestimonials';
import AdminUniversities from './pages/admin/AdminUniversities';
import AdminIntakes from './pages/admin/AdminIntakes';
import AdminStatusTypes from './pages/admin/AdminStatusTypes';
import AdminAgents from './pages/admin/AdminAgents';
import AdminCourses from './pages/admin/AdminCourses';
import AdminDashboard from './pages/admin/AdminDashboard';
import Contact from './pages/contact/Contact';
import Faq from './pages/faq/Faq';
import PageNotFound from './pages/404/PageNotFound';
import ComingSoon from './pages/comingsoon/ComingSoon';
import BlogClassic from './pages/blog/BlogClassic';
import BlogGrid from './pages/blog/BlogGrid';
import BlogDetails from './pages/blog/BlogDetails';
import Product from './pages/shop/Products';
import ProductDetails from './pages/shop/ProductDetails';
import Cart from './pages/shop/Cart';
import { AuthProvider } from './context/AuthContext';

function App() {
    return (
        <AuthProvider>
            <Router>
                <GlobalStyle />
                <ScrollToTop />
                <Switch>
                <Route exact path={`${process.env.PUBLIC_URL + "/"}`} component={HomeOne} />
                <Route path={`${process.env.PUBLIC_URL + "/about"}`} component={About} />
                <Route exact path={`${process.env.PUBLIC_URL + "/course-grid"}`} component={CourseGrid} />
                <Route exact path={`${process.env.PUBLIC_URL + "/course-list"}`} component={CourseList} />
                <Route exact path={`${process.env.PUBLIC_URL + "/courses"}`} component={CourseList} />
                <Route path={`${process.env.PUBLIC_URL + "/courses/:courseId"}`} component={CourseDetails} />
                <Route path={`${process.env.PUBLIC_URL + "/universities/:universityId"}`} component={UniversityDetails} />
                <Route path={`${process.env.PUBLIC_URL + "/instructor"}`} component={Instructor} />
                <Route path={`${process.env.PUBLIC_URL + "/instructor-details"}`} component={InstructorDetails} />
                <Route path={`${process.env.PUBLIC_URL + "/gallery"}`} component={Gallery} />
                <Route path={`${process.env.PUBLIC_URL + "/events"}`} component={Events} />
                <Route path={`${process.env.PUBLIC_URL + "/event-details"}`} component={EventDetails} />
                <Route path={`${process.env.PUBLIC_URL + "/login"}`} component={Login} />
                <Route path={`${process.env.PUBLIC_URL + "/registration"}`} component={Register} />
                <Route path={`${process.env.PUBLIC_URL + "/forgot-password"}`} component={ForgotPassword} />
                <Route path={`${process.env.PUBLIC_URL + "/reset-password"}`} component={ResetPassword} />
                <Route path={`${process.env.PUBLIC_URL + "/applications"}`} component={Applications} />
                <Route path={`${process.env.PUBLIC_URL + "/profile"}`} component={Profile} />
                <Route path={`${process.env.PUBLIC_URL + "/admin/dashboard"}`} component={AdminDashboard} />
                <Route path={`${process.env.PUBLIC_URL + "/admin/applications"}`} component={AdminApplications} />
                <Route path={`${process.env.PUBLIC_URL + "/admin/courses"}`} component={AdminCourses} />
                <Route path={`${process.env.PUBLIC_URL + "/admin/universities"}`} component={AdminUniversities} />
                <Route path={`${process.env.PUBLIC_URL + "/admin/intakes"}`} component={AdminIntakes} />
                <Route path={`${process.env.PUBLIC_URL + "/admin/statustypes"}`} component={AdminStatusTypes} />
                <Route path={`${process.env.PUBLIC_URL + "/admin/agents"}`} component={AdminAgents} />
                <Route path={`${process.env.PUBLIC_URL + "/admin/blogs"}`} component={AdminBlogs} />
                <Route path={`${process.env.PUBLIC_URL + "/admin/events"}`} component={AdminEvents} />
                <Route path={`${process.env.PUBLIC_URL + "/admin/instructors"}`} component={AdminInstructors} />
                <Route path={`${process.env.PUBLIC_URL + "/admin/users"}`} component={AdminUsers} />
                <Route path={`${process.env.PUBLIC_URL + "/admin/gallery"}`} component={AdminGallery} />
                <Route path={`${process.env.PUBLIC_URL + "/admin/testimonials"}`} component={AdminTestimonials} />
                <Route path={`${process.env.PUBLIC_URL + "/contact"}`} component={Contact} />
                <Route path={`${process.env.PUBLIC_URL + "/faq"}`} component={Faq} />
                <Route path={`${process.env.PUBLIC_URL + "/404"}`} component={PageNotFound} />
                <Route path={`${process.env.PUBLIC_URL + "/coming-soon"}`} component={ComingSoon} />
                <Route path={`${process.env.PUBLIC_URL + "/blog-classic"}`} component={BlogClassic} />
                <Route path={`${process.env.PUBLIC_URL + "/blog-grid"}`} component={BlogGrid} />
                <Route path={`${process.env.PUBLIC_URL + "/blog-details"}`} component={BlogDetails} />
                <Route path={`${process.env.PUBLIC_URL + "/products"}`} component={Product} />
                <Route path={`${process.env.PUBLIC_URL + "/product-details"}`} component={ProductDetails} />
                <Route path={`${process.env.PUBLIC_URL + "/cart"}`} component={Cart} />
                </Switch>
            </Router>
        </AuthProvider>
    )
}

export default App;
